import { Row, Col } from "react-bootstrap";
import "./counts.css";
// import { getCount } from "../../api/api";
import { useState, useEffect } from "react";
// import event from "../../assets/totalevent.svg";
// import venue from "../../assets/locationdark.svg";
// import sponsor from "../../assets/sponser.svg";
// import participant from "../../assets/participant.svg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { getCount } from "../../redux/api/api";

const Counts = () => {
  const [counts, setCounts] = useState({});
  const [startAnimation, setStartAnimation] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const fetchCounts = async () => {
    try {
      const res = await getCount();
      if (res.status === 200) {
        setCounts(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  useEffect(() => {
    if (inView) {
      setStartAnimation(true);
    }
  }, [inView]);

  return (
    <div ref={ref}>
      <Row className="countss">
        <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} className="counts">
          <div className="counts1">
            {/* <img src={participant} alt="counts" /> */}
          </div>
          <div className="counts2">
            <span>{startAnimation && <CountUp delay={0.5} start={0} end={counts.totalParticipant || 0} />}</span>
            <p>Participants</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} className="counts">
          <div className="counts1">
            {/* <img src={event} alt="counts" /> */}
          </div>
          <div className="counts2">
            <span>{startAnimation && <CountUp delay={0.5} start={0} end={counts.event || 0} />}</span>
            <p>Events</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} className="counts">
          <div className="counts1">
            {/* <img src={venue} alt="counts" /> */}
          </div>
          <div className="counts2">
            <span>{startAnimation && <CountUp delay={0.5} start={0} end={counts.venue || 0} />}</span>
            <p>Venues</p>
          </div>
        </Col>
        <Col xs={6} sm={6} md={6} lg={3} xl={3} xxl={3} className="counts">
          <div className="counts1">
            {/* <img src={sponsor} alt="counts" /> */}
          </div>
          <div className="counts2">
            <span>{startAnimation && <CountUp delay={0.5} start={0} end={counts.sponsor || 0} />}</span>
            <p>Sponsors</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Counts;
